import women from '../assets/images/icons/dress.png'
import men from '../assets/images/icons/blazer.png'
import jewelery from '../assets/images/icons/jewelry.png'
import electronic from '../assets/images/icons/electronic.png'

// export const category=[
//     {link:'/products?type=4',title:'زنانه',icon:women},
//     {link:'/products?type=3',title:'مردانه',icon: men},
//     {link:'/products?type=2',title:'جواهرات',icon: jewelery},
//     {link:'/products?type=1',title:'الکترونیکی',icon: electronic },
// ]

export const menuItems=[
    {link:'/',title:'صفحه اصلی'},
    {link:'/products',title:'محصولات',child:true},
    {link:'/',title:'درباره ما'},
    {link:'/',title:'تماس با ما'},
    // {link:'/details',title:'جزئیات'},
]


